<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div style="display: flex; justify-content: flex-end;">
          <v-menu offset-y>
            <template v-slot:activator="{on,attrs}">
              <v-btn
              color="primary"
              v-bind="attrs"
              v-on="on"
              >
                <v-icon>add_circle</v-icon>Add
              </v-btn>
            </template>
            <v-list>
              <v-list-tile @click="onRegister">
                <v-list-tile-content>
                  <v-list-tile-title>ADD NEW</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>
      
          <v-btn @click="showFilters = !showFilters" color="#FF4545">
            <v-icon>filter_list</v-icon>Filter
            <v-icon>{{ showFilters ? 'arrow_drop_up' : 'arrow_drop_down' }}</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12 v-if="showFilters">
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm4>
              <v-select
                :items="currencyList"
                label="Select Currency Name"
                item-text="name"
                item-value="id"
                v-model="queryParams.currencyId"
              ></v-select>
            </v-flex>
            <v-flex>
              <v-select
                :items="currencyList"
                label="Select Currency Code"
                item-text="code"
                item-value="id"
                v-model="queryParams.currencyId"
              ></v-select>
            </v-flex>
            <v-flex sm4>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :headers="headers"
            :items="currencyExchangeRateList"
            class="elevation-1"
            :loading="showListLoading"
            :rows-per-page-items="rowsPerPageItems"
            :total-items="totalRows"
            :pagination.sync="pagination"
            :must-sort="true"
          >
            <template slot="items" slot-scope="props">
              <td>{{ props.item.currencyDTO.name }}</td>
              <td>{{ props.item.currencyDTO.code }}</td>
              <td>{{ props.item.exchangeRate }}</td>
              <td>{{ props.item.createdDateInMilliSeconds | format-ms-date }}</td>
              <td>{{ props.item.createdBy }}</td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { currencyExchangeRateService } from "../../services/currency-exchange-rate-service";
import { currencyService } from "../../services/currency-service";

export default {
  name: "CurrencyExchangeList",

  components: {},
  data: () => ({
    showListLoading: false,
    showFilters: false,
    breadcrumbs: [
      {
        text: "Currency Management",
        disabled: true
      },
      {
        text: "Currency Exchange",
        disabled: true
      }
    ],
    headers: [
      { text: "Currency Name", align: "left", value: "currencyName" },
      { text: "Currency Code", align: "left", value: "currencyCode" },
      { text: "Exchange Rate", value: "exchangeRate" },
      { text: "Created Date", value: "createdDate" },
      { text: "Created By", value: "createdBy" }
    ],
    rowsPerPageItems: [25, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "createdDate",
      totalItems: 0
    },
    queryParams: {
      currencyId: ""
    },
    currencyList: [],
    currencyExchangeRateList: [],
    totalRows: 0,
    sortedBy: "createdDate,desc"
  }),
  watch: {
    pagination: {
      handler() {
        this.getCurrencyExchangeRateList();
      },
      deep: true
    }
  },
  created() {
    if (this.$route.query.currencyName) {
      this.queryParams.currencyName = this.$route.query.currencyName;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
    this.getCurrencyByStatus();
  },
  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({
        name: "currency-exchange-rates",
        query: this.queryParams
      });
      this.getCurrencyExchangeRateList();
    },

    getCurrencyByStatus() {
      currencyService
        .getCurrencyByStatus("ACTIVE")
        .then(res => {
          this.currencyList = res.data;
        })
        .catch(err => {
          console.log(err);
          if (err.response.data) {
            this.responseError = err.response.data.message;
          }
        });
    },

    getCurrencyExchangeRateList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      currencyExchangeRateService
        .getCurrencyExchangeRateList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )

        .then(res => {
          if (res.data) {
            this.currencyExchangeRateList = res.data.currencyExchangeRateList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },

    onRegister() {
      this.$router.push("/currency-exchange-rate/new");
    }
  }
};
</script>

<style scoped>
</style>